(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(hero) {
      var slides = hero.querySelectorAll('.promo-hero__slide');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('.promo-hero__dot');
      var current = 0;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10);
      if (isNaN(delay)) delay = 5000;
      var timer = null;

      function show(n) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (n + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }
      function next() { show(current + 1); }
      function start() {
        stop();
        if (delay > 0) timer = window.setInterval(next, delay);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      for (var i = 0; i < dots.length; i++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { show(idx); start(); });
        })(i);
      }
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) start();
    }

    function initAll() {
      var heroes = document.querySelectorAll('.promo-hero--slider');
      for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
